import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

export const createKey = () => ['paymentStates'];

const paymentStatesQuery = async () => {
  return request.get(
    `/Request/payment_states`,
    {},
    `При загрузке способов оплаты произошла ошибка`
  );
};

export const usePaymentStates = (options) =>
  useQuery(createKey(), paymentStatesQuery, options);
